import classNames from 'classnames/bind';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './WrongMission.module.scss';

import { PrimaryButton } from '@/components/ui/kit/Button';
import ModalWrapper from '@/components/ui/ModalWrapper';
import { modalManager } from '@/libs/ModalContainer';

const cx = classNames.bind(styles);

const Modal = () => {
  const navigate = useNavigate();

  const doConfirm = () => {
    navigate('/mission-hub', { replace: true });
    modalManager.hide();
  };

  return (
    <ModalWrapper disableEscape className={cx('container')}>
      <div className={cx('message')}>The mission does not exist.</div>
      <PrimaryButton text="OK" accent center onClick={doConfirm} />
    </ModalWrapper>
  );
};

export default Modal;
